import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { AlertService, ReportsService } from 'src/app/shared';

@Component({
  selector: 'app-score',
  templateUrl: './score.component.html',
  styleUrls: ['./score.component.scss']
})
export class ScoreComponent implements OnInit {

  model:any = [];
  filter: any = {
    key: ""
  };
  pageSize = 25;
  currentPage = 1;
  total = 0;
  criteria:any;

  constructor( private alert:AlertService, 
    private router: Router,
    private reportService: ReportsService) { }

  ngOnInit() {
  }

  getReport (){
    this.reportService.getScoreReport (this.criteria, this.filter, this.pageSize, this.currentPage)
    .pipe(first())
    .subscribe ((res:any)=>{
        this.model = res.data;
        this.total = res.count;  
    });
  }
  onReportClick (criteriaIn){
    this.criteria = criteriaIn;
    this.getReport ();
  }

  onDetailReport (row){
    var path = "/reports/cand-exam-res/" + row.centerid + "/" + row.batchid + "/" + row.candidate_id;
    
    this.router.navigate ([path]);
  }

  onLogsClick (row){
    var path = "/reports/cand-exam-res/" + row.centerid + "/" + row.batchid + "/" + row.candidate_id + "/logs";
  
    this.router.navigate ([path]);
  }

  onQuestions (row){
    var path = "/reports/cand-exam-res/" + row.centerid + "/" + row.batchid + "/" + row.candidate_id + "/questions";
  
    this.router.navigate ([path]);
  }

  onSeats (row){
    var path = "/reports/cand-exam-res/" + row.centerid + "/" + row.batchid + "/" + row.candidate_id + "/seats";
  
    this.router.navigate ([path]);
  }

  onPageChanged (e){
    this.currentPage = e;
    this.getReport();
  }
}
